function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open')
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if (event.currentTarget.className.indexOf('header__menu-item') > -1) {
      //<a> not working correctly (not opens the link) inside a <summary> tag in Safari
      //so we check if the customer is on a desktop with Safari we manually redirect
      const platformExpression = /Mac|Windows/i;
      const rejectedExpression =
        /Chrome|Android|CriOS|FxiOS|EdgiOS|iPhone|iPod|iPad|Mobile/i;
      const expectedExpression = /Safari/i;
      const agent = navigator.userAgent;
      if (
        !rejectedExpression.test(agent) &&
        platformExpression.test(agent) &&
        expectedExpression.test(agent)
      ) {
        window.location = event.currentTarget.childNodes[1].href;
        return;
      }
    }

    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone'){
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      );
    }
    else{
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      );
      // log(`${window.innerHeight}px`);
    }

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.no-close)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
    // this.querySelectorAll('button').forEach((button) =>
    //   button.addEventListener('click', this.onCloseButtonClick.bind(this))
    // );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector('summary')
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            'transitionend',
            addTrapFocus
          );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    $("#shopify-chat").removeClass("z-index-10");
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    $("#shopify-chat").addClass("z-index-10");

    this.header =
      this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
        this.closest('.header-wrapper').classList.contains(
          'header-wrapper--border-bottom'
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
      this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled')

    // active slide's color
    const activeSlide = this.querySelector('.slideshow__slide[aria-hidden="false"]')
    const activeBackgroundColor = activeSlide?.getAttribute('data-bgcolor')
    const activeFontColor = activeSlide?.getAttribute('data-fontcolor')

    if (activeBackgroundColor) {
      this.parentElement.parentElement.style.backgroundColor = activeBackgroundColor
    }

    if (activeFontColor) {
      const buttonEls = this.querySelectorAll('button')
      if (buttonEls.length) {
        buttonEls.forEach(b => b.style.color = activeFontColor)
      }
    }

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active'
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
        this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo(event);
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );

    if (mediaGallery) {
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );
    }

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo(event) {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );

        //const dest_drawer_options = document.getElementById('custom-drawer-title-container');
        //const source_drawer_options = html.getElementById('custom-drawer-title-container');

        const colorOptionElement = document.getElementById(
          'custom-selected-color'
        );
        if (colorOptionElement) {
          const customFabricModalOpener = document.getElementById('custom-fabric-details-modal-opener');
          if (window.custom_fabric_name == this.currentVariant?.option2) {
            colorOptionElement.innerText = '';
            if (customFabricModalOpener) {
              customFabricModalOpener.querySelector('span').innerText = window.custom_fabric_name + ' - ';
              customFabricModalOpener.style.display = 'flex';
            }
          } else {
            !!colorOptionElement
              ? (colorOptionElement.innerText = !!this.currentVariant
                ? this.currentVariant?.option2
                : '')
              : null;
            if (customFabricModalOpener) {
              customFabricModalOpener.style.display = 'none';
            }
          }
          if (document.querySelector('#sticky-overlay__product-color')) {
            document.querySelector('#sticky-overlay__product-color').innerHTML =
              colorOptionElement.innerText;
          }
        }
        if (source && destination) destination.innerHTML = source.innerHTML;
        //if (source_drawer_options && dest_drawer_options) dest_drawer_options.innerHTML = source_drawer_options.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        var stickyAddToCartButton = document.querySelector('#sticky-overlay__add-to-cart-button')
        var stickyConfigureButton = document.querySelector('#sticky-overlay__configure-button')
        stickyConfigureButton.style.display = 'none';
        stickyAddToCartButton.style.display = 'flex';

        if (window.custom_opt['is_customizable']) {
          var product_price_with_options = document.getElementById('product_price_with_options');
          var reg_price_el = document.getElementById('product_regular_price');
          var reg_price = reg_price_el.innerText
          if (reg_price.includes('$')) {
            reg_price = parseFloat(reg_price.replace(/[^\d.-]/g, "")) * 100;
          } else if (reg_price.indexOf('€') == -1) {
            reg_price = reg_price.replace(window.store_currency, '');
            reg_price = reg_price.replace('.', '');
            if (reg_price.indexOf(',') == -1) {
              reg_price = parseFloat(reg_price) * 100;
            } else {
              reg_price = reg_price.replace(',', '');
              reg_price = parseFloat(reg_price);
            }
          } else {
            reg_price = reg_price.replace(window.store_currency, '');
            reg_price = reg_price.replace(' EUR', '');
            reg_price = reg_price.replace(',', '');
            reg_price = parseFloat(reg_price) * 100;
          }


          // reg_price = reg_price.replace(',','');
          // reg_price = reg_price * 100;
          var price_dif = window.custom_opt['product_base_price'] - reg_price;
          window.custom_opt['product_variant_id'] = this.currentVariant.id;
          window.custom_opt['product_base_price'] = reg_price;
          window.custom_opt['price_with_options'] =
            window.custom_opt['price_with_options'] - price_dif;
          if (product_price_with_options) {
            if (
              Math.round(window.custom_opt['price_with_options'] / 100) ==
              window.custom_opt['price_with_options'] / 100
            ) {
              product_price_with_options.innerText =
                formatPriceWithCurrency(window.custom_opt['price_with_options'] / 100, window.store_currency);
            } else {
              product_price_with_options.innerText =
                formatPriceWithCurrency((window.custom_opt['price_with_options'] / 100).toFixed(2), window.store_currency);
            }
          }
          var product_mattress_el = document.getElementById('product_mattress');

          if (event.target.name.trim() == 'Type') {
            window.custom_opt['selected_product_type'] = event.target.value;
          }

          if (
            event.target.name.trim() !== 'Color' &&
            event.target.name.trim() !== 'Kleuren' &&
            event.target.name.trim() !== 'Farben' &&
            (event.target.name.trim() == 'Size' ||
              event.target.name.trim() == 'Maat' ||
              event.target.name.trim() == 'Set of options' ||
              event.target.name.trim() == 'Set van opties' ||
              event.target.name.trim() == 'options[Choose configuration]' ||
              event.target.name.trim() == 'options[Konfiguration wählen]' ||
              event.target.name.trim().indexOf('Kies jouw') != 1 ||
              event.target.name.trim() == 'Bettgröße wählen' ||
              event.target.name.trim() == 'Konfiguration wählen' ||
              event.target.name.trim() == 'Größe')
          ) {

            // HIDE 2 drawers for TEd and Tommy at size 70x140, 80x160, 90x160
            const drawerExceptions_for_products_1 = [7971660103958, 7964082045206];
            // The following beds will have NO  drawer option with the larger sized beds (>100 cm and up):
            // - MANOR - 7971659055382
            // - PIPPA - 7964081520918
            // - SIEN - 7971658498326
            // - TINTIN - 8402542002516
            // - DORIS - 8985129353556
            // - POPPY - 7971660333334
            const drawerExceptions_for_products_2 = [7971659055382, 7964081520918, 7971658498326, 8402542002516, 8985129353556, 7971660333334];

            // helper - workaround for legacy logic
            const backupProductId = parseInt(window.custom_opt['product_id2']);

            if (event.target.name.trim() == 'Size' || event.target.name.trim() == 'Maat' || event.target.name.trim() == 'Größe') {
              window.custom_opt['selected_bed_size'] = event.target.value;

              let hasProductException1, hasProductException2
              if (backupProductId) {
                hasProductException1 = drawerExceptions_for_products_1.includes(backupProductId)
                hasProductException2 = drawerExceptions_for_products_2.includes(backupProductId)
              }

              if (hasProductException1 || hasProductException2) {
                const bedSize = window.custom_opt['selected_bed_size']?.split('x').map(Number);
                const myBedLength = bedSize ? bedSize[1] : NaN;
                const myBedWidth = bedSize ? bedSize[0] : NaN;
                const drawerCtrEl = document.getElementById('drawer-accordion-panel');
                const noDrawerEl = document.getElementById(`drawer_no_drawer`)
                const twoDrawersEl = document.querySelector('div.custom-bed-option-container[data-drawer-title="2 drawers"]')

                if (twoDrawersEl && noDrawerEl && !isNaN(myBedLength) && !isNaN(myBedWidth)) {
                  const drawerException1 = hasProductException1 && ((myBedLength == 140 && myBedWidth == 70) || (myBedLength == 160 && (myBedWidth == 80 || myBedWidth == 90)))

                  if (drawerException1) {
                    noDrawerEl
                      .dispatchEvent(new Event('click'));
                    noDrawerEl.checked = true;

                    twoDrawersEl.style.display = "none";
                  } else {
                    twoDrawersEl.style.display = "block";
                  }
                } else {
                  console.error('Drawer logic missing or some other cool legacy 🐞')
                }


                if (drawerCtrEl && noDrawerEl && !isNaN(myBedLength) && !isNaN(myBedWidth)) {
                  const drawerException2 = hasProductException2 && myBedWidth > 100

                  if (drawerException2) {
                    noDrawerEl
                      .dispatchEvent(new Event('click'));
                    noDrawerEl.checked = true;

                    drawerCtrEl.style.display = "none";
                  } else {
                    drawerCtrEl.style.display = "flex";
                  }
                } else {
                  console.error('Drawer logic missing or some other cool legacy 🐞')
                }
              }
            }


            var drawer_option_items =
              document.getElementsByClassName('drawer-option-item');

            for (var i = 0, max = drawer_option_items.length; i < max; i++) {
              var drawer_option_name =
                drawer_option_items[i].attributes['data-drawer-name'].value;
              var bed_length = parseInt(
                window.custom_opt['selected_bed_size'].split('x')[1]
              );
              var sleepdrawer_id_list = [
                '43817124135190',
                '43644401877270',
                '43644401910038',
                '43817188491542',
              ];
              var bed_width = parseInt(
                window.custom_opt['selected_bed_size'].split('x')[0]
              );

              // Hack this 💩 to prevent hiding sleepdrawer with mattress if The bed is Tommy or TED - ticket: DEV-3812 with drawerExceptions_1
              if (
                (bed_length < 180 &&
                  drawer_option_items[i].attributes['data-drawer-id'].value ==
                  '43644401844502' && !drawerExceptions_for_products_1.includes(backupProductId)) ||
                (bed_width > 100 &&
                  sleepdrawer_id_list.includes(
                    drawer_option_items[i].attributes['data-drawer-id'].value
                  ) && !drawerExceptions_for_products_1.includes(backupProductId))
              ) {
                if (
                  document.getElementById(
                    `drawer_${drawer_option_items[i].attributes['data-drawer-id'].value}`
                  ).checked
                ) {
                  //The drawer we have to hide is selected, so must change selection and recalculate the price
                  if (
                    window.custom_opt['drawer_selected'] == 1 &&
                    drawer_option_items[i].attributes['data-drawer-id'].value ==
                    window.custom_opt['selected_drawer_id']
                  ) {
                    document.getElementById(`drawer_no_drawer`).checked = true;
                    document
                      .getElementById(`drawer_no_drawer`)
                      .dispatchEvent(new Event('click'));
                  }
                }
                drawer_option_items[i].style = 'display: none';
              } else {
                drawer_option_items[i].style = 'display: block';
              }

              // Hack this 💩 to prevent showing double drawers on 70x140 80x160 90x160 if The bed is Tommy or TED - ticket: DEV-3812 with drawerExceptions_1
              const isDoubleDrawer = drawer_option_items[i].attributes['data-drawer-id'].value == '43644401844502'
              const hasDrawerException = drawerExceptions_for_products_1.includes(backupProductId) && bed_width <= 90 && (bed_length == 140 || bed_length == 160)

              if (isDoubleDrawer && hasDrawerException) {
                drawer_option_items[i].style = 'display: none';
              } else {
                drawer_option_items[i].style = 'display: block';
              }
            }

            var first_selected_el = 1;
            var el = null;

            if (product_mattress_el) {
              for (
                var i = 0, max = product_mattress_el.children.length;
                i < max;
                i++
              ) {
                el = product_mattress_el.children[i];
                if (
                  el.children[0].attributes['data-mattresssize'].value ==
                  event.target.value.split(' ')[0]
                ) {
                  if (first_selected_el == 1) {
                    price_dif =
                      window.custom_opt['product_base_price'] - reg_price;
                    window.custom_opt['product_base_price'] = reg_price;
                    window.custom_opt['price_with_options'] =
                      window.custom_opt['price_with_options'] - price_dif;
                    window.custom_opt['selected_mattress_id'] =
                      el.children[0].value;
                    document.getElementById(
                      `mattress_quantity_input_${window.custom_opt['selected_mattress_id']}`
                    ).value = window.custom_opt['selected_mattress_quantity'];
                    if (window.custom_opt['mattress_selected'] == 1) {
                      window.custom_opt['price_with_options'] =
                        window.custom_opt['price_with_options'] -
                        window.custom_opt['selected_mattress_price'] *
                        window.custom_opt['selected_mattress_quantity'];
                      window.custom_opt['selected_mattress_price'] = parseInt(
                        el.children[0].attributes['data-mattressprice'].value
                      );
                      window.custom_opt['selected_mattress_price_diff'] =
                        (parseInt(
                          el.children[0].attributes[
                            'data-mattress-regular-price'
                          ].value
                        ) -
                          window.custom_opt['selected_mattress_price']) *
                        window.custom_opt['selected_mattress_quantity'];
                      window.custom_opt['price_with_options'] =
                        window.custom_opt['price_with_options'] +
                        window.custom_opt['selected_mattress_price'] *
                        window.custom_opt['selected_mattress_quantity'];
                      const price_to_show =
                        (window.custom_opt['selected_mattress_price'] *
                          window.custom_opt['selected_mattress_quantity']) /
                        100;
                      if (Math.round(price_to_show) == price_to_show) {
                        document.getElementById(
                          'selected_mattress_total_value'
                        ).innerHTML = formatPriceWithCurrency(price_to_show, window.store_currency);
                      } else {
                        document.getElementById(
                          'selected_mattress_total_value'
                        ).innerHTML =
                          formatPriceWithCurrency((Math.round(price_to_show) == price_to_show
                            ? price_to_show
                            : price_to_show.toFixed(2)), window.store_currency);
                      }
                    } else {
                      window.custom_opt['selected_mattress_price'] = parseInt(
                        el.children[0].attributes['data-mattressprice'].value
                      );
                      window.custom_opt['selected_mattress_price_diff'] =
                        (parseInt(
                          el.children[0].attributes[
                            'data-mattress-regular-price'
                          ].value
                        ) -
                          window.custom_opt['selected_mattress_price']) *
                        window.custom_opt['selected_mattress_quantity'];
                    }
                    product_price_with_options.innerText =
                      formatPriceWithCurrency(
                        getFormattedPrice(
                          window.custom_opt['price_with_options']
                        ), window.store_currency);
                    el.children[0].checked = 'checked';
                    first_selected_el = 0;
                  }
                  el.children[1].style.display = 'flex';
                } else {
                  el.children[1].style.display = 'none';
                }
              }
            }

            first_selected_el = 1;
            var has_fitted_sheet_available = 0;

            var product_fitted_sheet_el = document.getElementsByClassName(
              'custom-fitted-sheet-option'
            );
            const selectedBedSize = event.target.value.split(' ')[0];
            const associatedFittedSheet = window.fittedSheetSetting[selectedBedSize];

            let fitted_sheet_id;
            let fittedSheetSize;
            for (
              var i = 0, max = product_fitted_sheet_el.length;
              i < max;
              i++
            ) {
              el = product_fitted_sheet_el[i];
              fitted_sheet_id = el.attributes['data-fitted_sheetid'].value;
              fittedSheetSize = el.attributes['data-fitted_sheetsize']?.value;
              if (fittedSheetSize == associatedFittedSheet) {
                has_fitted_sheet_available = 1;
                el.style.display = 'flex';
              } else {
                var fitted_sheet_old_quantity =
                  window.custom_opt['selected_fitted_sheets'][fitted_sheet_id]
                    .quantity;
                var fitted_sheet_price =
                  window.custom_opt['selected_fitted_sheets'][fitted_sheet_id]
                    .price;
                var fitted_sheet_regular_price =
                  window.custom_opt['selected_fitted_sheets'][fitted_sheet_id]
                    .regular_price;

                if (document.getElementById(
                  'fitted_sheet_quantity_input_' + fitted_sheet_id
                )) {
                  document.getElementById(
                    'fitted_sheet_quantity_input_' + fitted_sheet_id
                  ).value = 0;
                }
                window.custom_opt['selected_fitted_sheets'][
                  fitted_sheet_id
                ].quantity = 0;
                el.style.display = 'none';
              }
            }

            if (window.custom_opt['selected_fitted_sheets_total_value'] !== undefined) {


              var fitted_sheet_qty = 0;
              var fitted_sheet_value = 0;
              var fitted_sheet_discount = 0;
              if (window.custom_opt['selected_fitted_sheets']) {
                Object.entries(window.custom_opt['selected_fitted_sheets']).forEach(
                  ([key, value]) => {
                    fitted_sheet_qty += value.quantity;
                    fitted_sheet_value += value.price * value.quantity;
                  }
                );
              }
              if (fitted_sheet_qty > 1) {
                fitted_sheet_discount =
                  fitted_sheet_value *
                  (window.custom_opt['fitted_sheet_qty_discount_percentage'] /
                    100);
              }

              window.custom_opt['price_with_options'] =
                window.custom_opt['price_with_options'] -
                window.custom_opt['selected_fitted_sheets_total_value'];
              window.custom_opt['selected_fitted_sheets_total_value'] =
                fitted_sheet_value - fitted_sheet_discount;
              window.custom_opt['selected_fitted_sheets_regular_total_value'] =
                fitted_sheet_value;
              window.custom_opt['price_with_options'] =
                window.custom_opt['price_with_options'] +
                window.custom_opt['selected_fitted_sheets_total_value'];
              product_price_with_options.innerText =
                formatPriceWithCurrency(getFormattedPrice(window.custom_opt['price_with_options']), window.store_currency);
              if (window.custom_opt['selected_fitted_sheets_total_value'] != 0) {
                document.getElementById(
                  'selected_fitted_sheets_total_value'
                ).innerText =
                  formatPriceWithCurrency(
                    getFormattedPrice(
                      window.custom_opt['selected_fitted_sheets_total_value']
                    ), window.store_currency);
              } else if (!window.custom_opt['is_headboard']) {
                document.getElementById(
                  'selected_fitted_sheets_total_value'
                ).innerText = '';
                document.getElementById(
                  'selected_fitted_sheets_regular_value'
                ).innerText = '';
              }

              var fitted_sheets_option = document.getElementById(
                'fitted_sheets_option'
              );
              if (has_fitted_sheet_available == 0) {
                window.custom_opt['fitted_sheet_selected'] = 0;
                if (fitted_sheets_option)
                  fitted_sheets_option.style = 'display: none';
              } else {
                window.custom_opt['fitted_sheet_selected'] = 1;
                if (fitted_sheets_option)
                  fitted_sheets_option.style = 'display: block';
              }
            }

          }
        }
        buildProductOptionsText();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
    const selectedColorPlaceholder = document.querySelector('#general-selected-color');
    if (selectedColorPlaceholder) {
      selectedColorPlaceholder.innerText = this.options[0];
    }
  }
}

customElements.define('variant-radios', VariantRadios);

function getFromLocalStorage(key) {
  if (typeof localStorage !== 'undefined') {
    var x = localStorage.getItem(key);
    return x;
  } else {
    return false;
  }
}
function saveToLocalStorage(key, value) {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(key, value);
    return true;
  } else {
    return false;
  }
}

class FilterButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onToggle);
    var hideShowbtn = window.document.getElementById('show-hide-filters');
    if (
      window.document.getElementById('facetsWrapper').style.display === 'block'
    ) {
      this.innerText = window.custom_opt['hide_filters'];
      hideShowbtn.classList.add('btn-style-2');
    } else {
      this.innerText = window.custom_opt['show_filters'];
      hideShowbtn.classList.remove("btn-style-2");
    }
  }

  onToggle() {
    var facetsWrapper = window.document.getElementById('facetsWrapper');
    var hideShowbtn = window.document.getElementById('show-hide-filters');

    // var column_nr_change = 1;
    var column_nr_change = 0;
    if (facetsWrapper.style.display === 'block') {
      facetsWrapper.style.opacity = 0;
      saveToLocalStorage("v_filters", "hide");
      hideShowbtn.classList.remove("btn-style-2");

      window.setTimeout(function () {
        facetsWrapper.style.display = 'none';
      }, 300);
      this.innerText = window.custom_opt['show_filters'];
    } else {
      facetsWrapper.style.display = 'block';
      saveToLocalStorage("v_filters", "show");
      hideShowbtn.classList.add('btn-style-2');

      window.setTimeout(function () {
        facetsWrapper.style.opacity = 1;
      }, 0);
      this.innerText = window.custom_opt['hide_filters'];
      // column_nr_change = -1;
      column_nr_change = 0;
    }

    var product_grid = document.getElementById('product-grid');
    product_grid.classList.forEach((el) => {
      if (el.indexOf('-desktop') != -1) {
        product_grid.classList.remove(el);
        var one_more_column = parseInt(el.slice(6, 7)) + column_nr_change;
        product_grid.classList.add(`grid--${one_more_column}-col-desktop`);
      }
    });
  }
}

customElements.define('filter-button', FilterButton);


// checkthis
class YesNoOption extends HTMLElement {
  constructor() {
    super();
    const input = this.querySelector('input');
    input.addEventListener('change', this.onOptionChange.bind(this));
    window.custom_opt[`selected_${this.dataset.optionname}_id`] = '0';
    window.custom_opt[`selected_${this.dataset.optionname}_price`] = 0;
    window.custom_opt[`${this.dataset.optionname}_selected`] = 0;
  }

  onOptionChange(event) {
    // alert(' -pre-'+ this.dataset.optionname + " " + JSON.stringify(window.custom_opt[`${this.dataset.optionname}_selected`]))
    if (!event.target.checked) {
      window.custom_opt[`${this.dataset.optionname}_selected`] = 1;
      window.custom_opt[`selected_${this.dataset.optionname}_id`] =
        event.target.attributes[`data-${this.dataset.optionname}_id`].value;
      window.custom_opt[`selected_${this.dataset.optionname}_price`] = parseInt(
        event.target.attributes[`data-${this.dataset.optionname}_price`].value
      );
      window.custom_opt['price_with_options'] =
        window.custom_opt['price_with_options'] +
        window.custom_opt[`selected_${this.dataset.optionname}_price`];
      if (
        Math.round(window.custom_opt['price_with_options'] / 100) ==
        window.custom_opt['price_with_options'] / 100
      ) {
        product_price_with_options.innerText =
          formatPriceWithCurrency(window.custom_opt['price_with_options'] / 100, window.store_currency);
      } else {
        product_price_with_options.innerText =
          formatPriceWithCurrency((window.custom_opt['price_with_options'] / 100).toFixed(2), window.store_currency);
      }
    } else {
      // alert('unchecked')
      window.custom_opt[`${this.dataset.optionname}_selected`] = 0;
      window.custom_opt[`selected_${this.dataset.optionname}_id`] = '0';
      window.custom_opt['price_with_options'] =
        window.custom_opt['price_with_options'] -
        window.custom_opt[`selected_${this.dataset.optionname}_price`];
      if (
        Math.round(window.custom_opt['price_with_options'] / 100) ==
        window.custom_opt['price_with_options'] / 100
      ) {
        product_price_with_options.innerText =
          formatPriceWithCurrency(window.custom_opt['price_with_options'] / 100, window.store_currency);
      } else {
        product_price_with_options.innerText =
          formatPriceWithCurrency((window.custom_opt['price_with_options'] / 100).toFixed(2), window.store_currency);
      }
      window.custom_opt[`selected_${this.dataset.optionname}_price`] = 0;
    }
    // alert(' -after- '+ this.dataset.optionname + " " + JSON.stringify(window.custom_opt[`${this.dataset.optionname}_selected`]))

    buildProductOptionsText();
  }
}

customElements.define('yes-no-option', YesNoOption);

function getFormattedPrice(value) {
  if (Math.round(value / 100) == value / 100) {
    return value / 100;
  } else {
    return (value / 100).toFixed(2);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const leg_height_option_20 = document.querySelector('.leg-height-toggle-special');
  if (leg_height_option_20) {
    if (leg_height_option_20.checked) {
      leg_height_option_20.dispatchEvent(new Event('click'));
    }
  }
  const extra_barrier_length_23 = document.querySelector('.extra-barrier-length-toggle-23');
  if (extra_barrier_length_23) {
    extra_barrier_length_23.dispatchEvent(new Event('click'));
  }

  const protective_barrier_added = document.querySelector('#protective_barrier_added');
  if (protective_barrier_added && window.instockExpressBed) {
    protective_barrier_added.dispatchEvent(new Event('change'));

  }

  // TOGGLE slide vs climbing wall
  const slideOptionEl = document.getElementById('slide_added');
  const climbingWallOptionEl = document.getElementById('climbing_wall_added');
  if (slideOptionEl && climbingWallOptionEl) {
    slideOptionEl.addEventListener('change', (e) => {
      if (window.custom_opt['slide_selected'] == 1 && window.custom_opt['climbing_wall_selected'] == 1) {
        climbingWallOptionEl.checked = true
        climbingWallOptionEl?.dispatchEvent(new Event('change'))
      }
    })
    climbingWallOptionEl.addEventListener('change', (e) => {
      if (window.custom_opt['slide_selected'] == 1 && window.custom_opt['climbing_wall_selected'] == 1) {
        slideOptionEl.checked = true
        slideOptionEl?.dispatchEvent(new Event('change'))
      }
    })
  }

  // HIDE slide option other than "height under bed 70cm"
  const underBedCtrEl = document.getElementById('under-bed')
  const slideAccordionEl = document.getElementById('slide-accordion-panel')
  if (underBedCtrEl && slideAccordionEl && slideOptionEl) {
    // on init
    if (window.custom_opt['height_under_bed_selected'] !== 0) {
      slideAccordionEl.classList.add('hidden')
      slideOptionEl.checked = true
      slideOptionEl?.dispatchEvent(new Event('change'))
    }

    // on change
    underBedCtrEl.addEventListener('change', (e) => {
      if (e.target.id === "height_under_bed_70cm") {
        slideAccordionEl.classList.remove('hidden')
      } else {
        slideAccordionEl.classList.add('hidden')
        slideOptionEl.checked = true
        slideOptionEl?.dispatchEvent(new Event('change'))
      }
    })
  }
});


// left on top price there is text from product selected options...
// Checkthis
const buildProductOptionsText = function () {
  let productOptionsText = '';

  if (document.querySelector('.custom-product-option-dropdown')) {
    productOptionsText += document.querySelector('.custom-product-option-dropdown').selectedOptions[0].innerText.trim();
  }

  if (document.querySelector('#general-selected-color')) {
    productOptionsText += document.querySelector('#general-selected-color').innerText;
  } else if (document.querySelector('#custom-selected-color')) {
    productOptionsText += document.querySelector('#custom-selected-color').innerText;
  } else {
    if (window.custom_opt['selected_color_option_title']) {
      productOptionsText += window.custom_opt['selected_color_option_title'];
    }
  }
  

  if (window.custom_opt['selected_bed_size'] && window.custom_opt['price_with_options']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['selected_bed_size'];
  }

  if (window.custom_opt['selected_product_type']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['selected_product_type'];
  }

  if (window.custom_opt['selected_headboard_title']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['selected_headboard_title'];
  }

  if (window.custom_opt['selected_headboard_width_title']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['selected_headboard_width_title'];
  }

  if (window.custom_opt['topper_options_value']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['topper_options_value'];
  }

  if (window.custom_opt['boxspring_leg_options_value']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['boxspring_leg_options_value'];
  }

  if (window.custom_opt['selected_drawer_title']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['selected_drawer_title'];
  }

  if (window.custom_opt['selected_leg_height_value']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['selected_leg_height_value'];
  }

  if (window.custom_opt['entry_positions_option_value']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['entry_positions_option_value'];
  }

  if (window.custom_opt['staircase_position_option_value']) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_opt['staircase_position_option_value'];
  }

  if (window.custom_opt['protective_barrier_selected'] == 1) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_trans['sticky_protective_barrier'];
  }

  if (window.custom_opt['extra_barrier_height_selected'] == 0) {
    productOptionsText += ' - ' + window.custom_trans['sticky_barrier_height'] + " 25 cm";
  } else if (window.custom_opt['extra_barrier_height_selected'] == 1) {
    productOptionsText += ' - ' + window.custom_trans['sticky_barrier_height'] + " 35 cm";
  }

  if (window.custom_opt['extra_barrier_lenght_selected'] == 0) {
    productOptionsText += ' - ' + window.custom_trans['sticky_barrier_length'] + " 1/2";
  } else if (window.custom_opt['extra_barrier_lenght_selected'] == 1) {
    productOptionsText += ' - ' + window.custom_trans['sticky_barrier_length'] + " 2/3";
  }

  if (window.custom_opt['climbing_wall_selected'] == 1) {
    productOptionsText += ' - ' + window.custom_trans['sticky_climbing_wall'];
  }

  if (window.custom_opt['slide_selected'] == 1) {
    productOptionsText += ' - ' + window.custom_trans['sticky_slide'];
  }

  if (window.custom_opt['chimney_selected'] == 1) {
    productOptionsText += ' - ' + window.custom_trans['sticky_chimney'];
  }

  if (window.custom_opt['barrier_positions_option_selected'] == 1) {
    productOptionsText += ' - ' + window.custom_trans['sticky_barrier'] + window.custom_opt['barrier_positions_option_value'];
  }

  if (window.custom_opt["use_new_customizer"]) {
    productOptionsText = '';
    $(".related-products-wrapper").each(function (index) {
      var block_display = $(this).css("display")
      if (block_display != "none") {

        var new_customizer = $(this).attr("new-customizer");
        if (new_customizer == "true") {
          var $input = $(this).find(".customizer-option-list input[checked2='checked']");
          if ($input) {
            var customizer_text = $input.attr("data-customizer-title");
            if (customizer_text == undefined) {
              customizer_text = "";
            }
            if (productOptionsText != "") {
              productOptionsText = productOptionsText + " - " + customizer_text;
            }
            else {
              productOptionsText = customizer_text;
            }
          }
        }
        else {
          if (window.custom_opt['selected_bed_size'] && window.custom_opt['price_with_options']) {
            if (productOptionsText != "") {
              productOptionsText += " - ";
            }
            productOptionsText += window.custom_opt['selected_bed_size'];
          }
        }
      }
    });
  }

  if (window.custom_opt['mattress_selected'] == 1) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_trans['sticky_mattress'];
  }

  if (window.custom_opt['fitted_sheet_selected'] == 1 && window.custom_opt['selected_fitted_sheets_total_value'] != 0) {
    if (productOptionsText != "") {
      productOptionsText += " - ";
    }
    productOptionsText += window.custom_trans['sticky_fitted_sheet'];
  }


  if (document.querySelector("#sticky-overlay__product-options")) {
    document.querySelector("#sticky-overlay__product-options").innerHTML = productOptionsText;
  }

  //update price for non custom bed products
  if (!window.custom_opt['price_with_options'] && (document.getElementById('sticky-overlay__product-price')) && (document.getElementById('product_regular_price'))) {
    document.getElementById('sticky-overlay__product-price').innerHTML = document.getElementById('product_regular_price').innerHTML;
  }

  if (!window.custom_opt['price_with_options'] && (document.getElementById('sticky-overlay__product-orig-price')) && (document.getElementsByClassName('price-item--regular custom-original-price')[0])) {
    document.getElementById('sticky-overlay__product-orig-price').innerHTML = document.getElementsByClassName('price-item--regular custom-original-price')[0].innerHTML;
    document.getElementById('sticky-overlay__product-orig-price').style.display = 'block';
  }

}

if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]',
          ),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener(
          'click',
          this.openSelector.bind(this),
        );
        this.elements.button.addEventListener(
          'focusout',
          this.closeSelector.bind(this),
        );
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) =>
          item.addEventListener('click', this.onItemClick.bind(this)),
        );
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false')
          return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (
            this.elements.button.getAttribute('aria-expanded') === 'false'
          ).toString(),
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) ||
          this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    },
  );
}

// show/hide add to cart button in header only when we scroll down and pass main add to cart button
// desktop
function checkElementVisible_MainAddToCart() {
  var windowsize = $(window).width();
  if (windowsize > 749) {
    var $element = $('.custom-buy-buttons-container');
    if ($element.length === 0) return;
    var elementTop = $element.offset().top;
    var elementBottom = elementTop + $element.outerHeight();
    var scrollTop = $(window).scrollTop() + 50;
    var windowBottom = scrollTop + $(window).height();
    if (elementBottom < scrollTop) {
      // log('Element is no longer visible (scrolled past).');
      $(".sticky-overlay__base").css("display", "block")
      // $(".sticky-overlay__wrapper").css("grid-template-columns","1fr 10fr 1fr");
    } else {
      // log('Element is still visible.');
      $(".sticky-overlay__base").css("display", "none")
      // $(".sticky-overlay__wrapper").css("grid-template-columns","1fr 11.4fr 0fr");
    }
  }
}
function checkElementVisible_MainImage_container() {
  var windowsize = $(window).width();
  if (windowsize > 749) {
    var $element = $('.product-media-g-container');
    if ($element.length === 0) return;
    var elementTop = $element.offset().top;
    var elementBottom = elementTop + $element.outerHeight();
    var scrollTop = $(window).scrollTop() + 50;
    var windowBottom = scrollTop + $(window).height();
    if (elementBottom < scrollTop) {
      $(".sticky-overlay__wrapper").css("grid-template-columns", "1fr 10fr 1fr");
      $(".cart-notification-product__image").css("display", "block");
    } else {
      $(".sticky-overlay__wrapper").css("grid-template-columns", "13.4fr 0fr");
      $(".cart-notification-product__image").css("display", "none");
    }
  }
  else {
    $(".cart-notification-product__image").css("display", "block");
    $(".sticky-overlay__wrapper").css("grid-template-columns", "1fr 10fr 1fr");
  }
}
// end show/hide on desktop

// sticky overlay mobile

// show/hide after/before images container
function checkElementVisible_MainImage_container_mobile() {
  var windowsize = $(window).width();
  if (windowsize < 750) {
    var $element = $('.product-media-g-container');
    if ($element.length === 0) return;
    var elementTop = $element.offset().top;
    var elementBottom = elementTop + $element.outerHeight();
    var scrollTop = $(window).scrollTop() + 50;
    var windowBottom = scrollTop + $(window).height();
    if (elementBottom < scrollTop) {
      // $(".sticky-overlay__wrapper").css("grid-template-columns","1fr 10fr 1fr");
      $(".sticky-overlay__base").css("display", "block");
    } else {
      // $(".sticky-overlay__wrapper").css("grid-template-columns","13.4fr 0fr");
      $(".sticky-overlay__base").css("display", "none");
    }
  }
}

// show hide overlay price
function checkElementVisible_MainAddToCart_Mobile() {
  var windowsize = $(window).width();
  if (windowsize < 750) {
    var $element = $('.custom-buy-buttons-container');
    if ($element.length === 0) return;
    var elementTop = $element.offset().top;
    var elementBottom = elementTop + $element.outerHeight();
    var scrollTop = $(window).scrollTop() + 50 + 90;
    var windowBottom = scrollTop + $(window).height();
    if (elementBottom < scrollTop) {
      $(".sticky-overlay__product-price-wrapper").css("display", "flex");
      $(".sticky-overlay__action-wrapper").css("display", "flex");
      // $(".sticky-overlay__wrapper").css("grid-template-columns", "1fr 10fr 1fr");
    } else {
      $(".sticky-overlay__product-price-wrapper").css("display", "none");
      $(".sticky-overlay__action-wrapper").css("display", "none");
      // $(".sticky-overlay__wrapper").css("grid-template-columns", "1fr 11.4fr 0fr");
    }
  }
}
// end sticky overlay mobile


$(window).on('scroll', function () {
  checkElementVisible_MainAddToCart();
  checkElementVisible_MainImage_container();

  checkElementVisible_MainImage_container_mobile();
  checkElementVisible_MainAddToCart_Mobile();
});
$(document).ready(function () {
  checkElementVisible_MainAddToCart();
});
